import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { IClientDeviceModel } from '../../shared/models/auth.model';

@Injectable({
  providedIn: 'root'
})
export class ClientIpService {

  constructor(private readonly http: HttpClient) { }

  getClientIp() {
    return this.http.get<IClientDeviceModel>('https://ipinfo.io/json');
  }
}
